import { createGlobalStyle, css } from 'styled-components/macro';
import { device } from './MediaQuery';

import { Theme } from 'theme/contracts';

const styles = css`
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  html,
  body,
  #root {
    min-height: 100vh;
  }

  body {
    font-family: ${({ theme }) => `'${theme.mainFontFamily}', sans-serif`};
    background-color: ${({ theme }) => theme.grayColor4};
    color: ${({ theme }) => theme.whiteColor};
    font-size: 14px;

    @media print {
      background-color: ${({ theme }) => theme.whiteColor};
    }
  }

  button,
  input,
  textarea {
    font-family: ${({ theme }) => `'${theme.mainFontFamily}', sans-serif`};
  }

  input,
  textarea {
    -webkit-text-fill-color: ${({ theme }) => theme.whiteColor};
    caret-color: ${({ theme }) => theme.whiteColor};
  }

  *:focus,
  *:active {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  h1 {
    font-weight: 700;
    font-size: 20px;
    line-height: 1.4;
    letter-spacing: 0.03em;
    margin-bottom: 16px;
  }
  .dark-bg {
    position: relative;
    &::after {
      position: absolute;
      content: '';
      background-color: black;
      width: 100%;
      height: 100%;
      left: 0;
      z-index: -1;
      filter: blur(30px);
    }
  }

  /* Change the white to any color */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px ${({ theme }) => theme.grayColor4} inset !important;
    -webkit-text-fill-color: ${({ theme }) => theme.whiteColor} !important;
    color: ${({ theme }) => theme.whiteColor} !important;
    background-color: ${({ theme }) => theme.grayColor4} !important;
    /* transition: background-color 2147483647s; */
    cursor: text;
    caret-color: ${({ theme }) => theme.whiteColor} !important;
  }
  a {
    color: ${({ theme }) => theme.greenColor};
    text-decoration: none;
  }

  #nprogress {
    pointer-events: none;
    .bar {
      background: ${({ theme }) => theme.greenColor} !important;

      position: fixed !important;
      z-index: 1113 !important;
      top: 0 !important;
      left: 0 !important;

      width: 100% !important;
      height: 3px !important;
    }

    /* Fancy blur effect */
    .peg {
      box-shadow: 0 0 10px ${({ theme }) => theme.greenColor},
        0 0 5px ${({ theme }) => theme.greenColor} !important;
    }
  }

  #devcode_popup {
    color: ${({ theme }) => theme.blackColor};
  }

  .hidden {
    display: block;
    height: 0;
    width: 0;
    opacity: 0;
    visibility: hidden;
  }

  .i-embedded-form,
  .i-embedded-chat {
    @media (${device.mobile}) {
      bottom: 102px !important;
    }
  }
`;

export const GlobalStyles = createGlobalStyle<{ theme: Theme }>`${styles}`;
